import { render } from "./WpeTextarea.vue?vue&type=template&id=5676ef9d"
import script from "./WpeTextarea.vue?vue&type=script&lang=js"
export * from "./WpeTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5676ef9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5676ef9d', __exports__)) {
    api.reload('5676ef9d', __exports__)
  }
  
  module.hot.accept("./WpeTextarea.vue?vue&type=template&id=5676ef9d", () => {
    api.rerender('5676ef9d', render)
  })

}


export default __exports__